import $ from 'jquery';

import plugin from './plugin';

class PluginSwitch {

	constructor(element, options) {
		const $element = this.$element = $(element);
		this.$switch = $element.find('.m-switch-switch')
			.on('click', () => this.toggleState());
		this.$left = $element.find('.m-switch-toggle-left')
			.on('click', () => this.changeState(false));
		this.$right = $element.find('.m-switch-toggle-right')
			.on('click', () => this.changeState(true));

		this.$contentLeft = $element.find('.m-switch-content-left');
		this.$contentRight = $element.find('.m-switch-content-right');
		this.state = this.$switch.hasClass('active');

		this.render();
	}

	changeState(value) {
		this.state = value;
		this.render();
	}

	toggleState() {
		this.state = !this.state;
		this.render();
	}

	render() {
		this.$element[this.state ? 'addClass' : 'removeClass']('active');
		this.$contentLeft[this.state ? 'hide' : 'show']();
		this.$contentRight[!this.state ? 'hide' : 'show']();
		this.$element.trigger('switchrender');
	}
}

plugin('PluginSwitch', PluginSwitch);

